import { OverridesStyleRules } from '@mui/material/styles/overrides'

const MuiInputBase: OverridesStyleRules = {
    defaultProp: {},
    styleOverrides: {},
    variants: [],
}

export default MuiInputBase
